import request from '@/utils/request'

// 長龍
const getChangLongContinuousList = function(query) {
  return request({
    url: '/v1/cp168/apis/cpStatisticsByStatsType/nowDragon',
    method: 'get',
    params: query
  })
}

// 遺漏
const getChangLongMissingList = function(query) {
  return request({
    url: '/v1/cp168/apis/cpStatisticsByStatsType/nowMissingDragon',
    method: 'get',
    params: query
  })
}

export {
  getChangLongContinuousList,
  getChangLongMissingList
}
